var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-search-item flex-center",attrs:{"colspan":_vm.colspan}},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_c('span',{staticStyle:{"width":"12px"}}),_c('div',{staticClass:"flex-grow"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }